const normalizeSubscriptionStatus = (status?: string | null): string =>
  String(status ?? '')
    .trim()
    .toLowerCase()
    .replace(/_/g, ' ');

export const getSubscriptionDisplayStatus = (
  status?: string | null,
  cancelAtPeriodEnd?: boolean,
): string => {
  const normalized = normalizeSubscriptionStatus(status);
  if (normalized === 'canceled' || normalized === 'cancelled') {
    return 'canceled';
  }
  if (cancelAtPeriodEnd && normalized === 'active') {
    return 'canceled';
  }
  return normalized;
};

export type SubscriptionStatusKey = 'active' | 'paused' | 'canceled' | 'expired' | 'past_due';

const STATUS_KEYS: Record<string, SubscriptionStatusKey> = {
  active: 'active',
  paused: 'paused',
  canceled: 'canceled',
  expired: 'expired',
  'past due': 'past_due',
};

export const getSubscriptionStatusKey = (status?: string | null): SubscriptionStatusKey | null =>
  STATUS_KEYS[normalizeSubscriptionStatus(status)] ?? null;

export const formatSubscriptionStatusLabel = (status?: string | null): string => {
  const normalized = normalizeSubscriptionStatus(status);
  if (!normalized) return '—';

  return normalized
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const isEndedSubscriptionDisplayStatus = (status?: string | null): boolean => {
  const normalized = normalizeSubscriptionStatus(status);
  return normalized === 'canceled' || normalized === 'expired';
};

export const isWarningSubscriptionDisplayStatus = (status?: string | null): boolean => {
  const normalized = normalizeSubscriptionStatus(status);
  return normalized === 'paused' || normalized === 'past due';
};

export const getSubscriptionStatusDotColor = (status?: string | null): string => {
  if (isEndedSubscriptionDisplayStatus(status)) return '#DC2626';
  if (isWarningSubscriptionDisplayStatus(status)) return '#D97706';
  return '#16A34A';
};
